import _ from 'lodash';
import getInit from '../apis/commonInit';
import { setCookie, getCookie } from './commonInitCookie.umd';

export default function getCommonInit() {
    return new Promise((resolve, reject) => {
        let isNeedAjax = false;
        let refresh = getCookie('refreshInit');
        // 记录当前页面为登陆后跳回保存快照
        if (refresh !== 'false') {
            isNeedAjax = true;
        } else {
            let initData = localStorage.getItem('commonInitData');
            if (initData) {
                initData = JSON.parse(initData);
                resolve(initData);
            } else {
                isNeedAjax = true;
            }
        }
        if (isNeedAjax === true) {
            getInit().then(res => {
                let data = {
                    globalConfig: _.get(res, 'data')
                };
                if (data) {
                    try {
                        localStorage.setItem('commonInitData', JSON.stringify(data));
                        setCookie('refreshInit', false);
                    } catch (err) {
                        setCookie('refreshInit', true);
                        //FIX ME TODO when localStorage not allow to use
                        // return true;
                    }
                    resolve(data);
                }
            }).catch(error => {
                reject(error);
            });
        }
    });
}
